import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import {
  FormGroup, FormControlLabel, Checkbox, Typography, Autocomplete,
  Tooltip
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TextField from '@mui/material/TextField';
import { FormLabel, RadioGroup, FormControl, Radio, Select, InputLabel, MenuItem } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomAutocomplete from '../../../Components/AutoComplete/AutocompletewithoutIcon';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import axiosInstance from '../../../lib/axios';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { InputAdornment } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PreviousEnquiriesList from './PreviousEnquiriesList';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const columns = [
  { id: 'RowNum', label: 'SrNo', minWidth: 10 },
  { id: 'EnqNo', label: 'EnqNo', minWidth: 10 },
  { id: 'EnqDt', label: 'Date', minWidth: 10 },
  { id: 'SourceName', label: 'SourceName', minWidth: 10 },
  { id: 'BrokerName', label: 'Broker', minWidth: 10 },
  { id: 'EnqType', label: 'EnqType', minWidth: 10 },
  { id: 'EnqBy', label: 'EnqBy', minWidth: 10 },
  { id: 'EmailId', label: 'EmailId', minWidth: 10 },
  { id: 'EnqFor', label: 'EnqFor', minWidth: 10 },
  { id: 'Tenure', label: 'Tenure', minWidth: 10 },
  { id: 'CheckInDt', label: 'CheckInDt', minWidth: 10 },
  { id: 'RoomTypeName', label: 'RoomType', minWidth: 10 },
  { id: 'FlwEmpNm', label: 'FlwEmpNm', minWidth: 10 },
  { id: 'VisitSt', label: 'VisitSt', minWidth: 10 },
  { id: 'VisitDt', label: 'VisitDt', minWidth: 10 },
  { id: 'VisitRemark', label: 'VisitRemark', minWidth: 10 },
];

const EnquiryMain = () => {

  const [formData, setFormData] = useState({
    PropId: "",
    EnqNo: "",
    EnqDt: moment().format('DD/MM/YYYY'),
    SourceId: "",
    SourceName: "",
    BrokerId: "",
    EnqType: "",
    EnqBy: "",
    MobileNo: "",
    EmailId: "",
    EnqFor: "",
    Address: "",
    Tenure: "0",
    CheckInDt: moment().format('DD/MM/YYYY'),
    RoomTypeId: "",
    PreviousStayNm: "",
    Remark: "",
    Status: "",
    BookId: "",
    FlwUserId: "",
    VisitSt: "N",
    VisitDt: moment().format('DD/MM/YYYY'),
    VisitUserId: "",
    VisitRemark: "",
    CanlDt: "",
    CanlUserId: "",
    CanlRemark: "",
    CreatedBy: "",
    RelationId: "",
    InstituteId: "",
    NextFlwDt: "",
    SemesterId: "",
    CourseId: "",
    DesiId: "",
    Occupation: "S",
    OcupntMob: '',
    enquiryStatus: 'open',
    // FlwUserId: "",
  });

  const [error, setError] = useState({
    EnqBy: false,
    EnqFor: false,
    MobileNo: false,
    CheckInDt: false,
    BookId: false
  });

  const navigate = useNavigate();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentEnqId, setCurrentEnqId] = useState(null);
  const [mode, setMode] = useState('view');
  const [lastInsertedEnqId, setLastInsertedEnqId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const UserId = sessionStorage.getItem('UserId')
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const [Propertydrp, setPropertydrp] = useState([]);
  const [JobTitle, setJobTitle] = useState([]);
  const [semester, setSemester] = useState([]);
  const [sourceBy, setsourceBy] = useState([]);
  const [Broker, setBroker] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [course, setCourse] = useState([]);
  const [EnqType, setEnqType] = useState([]);
  const [RoomType, setRoomType] = useState([]);
  const [Types, setTypes] = useState([]);
  const [BookNo, setBookNo] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [displayCalendar, setDisplayCalendar] = useState(false);
  const [viewCalendar, setViewCalendar] = useState(false);
  const [FollowCalendar, setFollowCalendar] = useState(false);
  const [typedBookNo, setTypedBookNo] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isBookIdValid, setIsBookIdValid] = useState(false);
  const [tomorrowDate, setTomorrowDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  });
  const [enqId, setEnqId] = useState(null)
  const [Relation, setRelation] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const SourceNameRef = useRef(null);
  const EnqTypeRef = useRef(null);
  const MobileNoRef = useRef(null);
  const [previousEnquiries, setPreviousEnquiries] = useState([]);
  const [showPreviousEnquiries, setShowPreviousEnquiries] = useState(false);
  const { enqIdData } = useParams();

  // useEffect(() => {
  //   const initializeFormData = () => {
  //     const initialFormData = {
  //       // PropId: Propertydrp.length > 0 ? Propertydrp[1]?.Id.toString() : "",
  //       EnqNo: "",
  //       EnqDt: moment().format('DD/MM/YYYY'),
  //       SourceId: sourceBy.length > 0 ? sourceBy[1]?.Id.toString() : "",
  //       SourceName: "",
  //       BrokerId: Broker.length > 0 ? Broker[1]?.Id.toString() : "",
  //       EnqType: EnqType.length > 0 ? EnqType[1]?.Id.toString() : "",
  //       EnqBy: "",
  //       MobileNo: "",
  //       EmailId: "",
  //       EnqFor: "",
  //       Address: "",
  //       Tenure: "0",
  //       CheckInDt: moment().format('DD/MM/YYYY'),
  //       RoomTypeId: RoomType.length > 0 ? RoomType[1]?.Id.toString() : "",
  //       PreviousStayNm: "",
  //       Remark: "",
  //       Status: "",
  //       NextFlwDt: moment().add(1, 'days').format('DD/MM/YYYY'),
  //       BookId: "",
  //       FlwUserId: Types.length > 0 ? Types[0]?.Id.toString() : "",
  //       VisitSt: "N",
  //       VisitDt: moment().format('DD/MM/YYYY'),
  //       VisitUserId: "",
  //       VisitRemark: "",
  //       CanlDt: "",
  //       CanlUserId: "",
  //       CanlRemark: "",
  //       CreatedBy: "",
  //       RelationId: Relation.length > 0 ? Relation[1]?.Id.toString() : "",
  //       InstituteId: institutions.length > 0 ? institutions[1]?.Id.toString() : "",
  //       SemesterId: semester.length > 0 ? semester[1]?.Id.toString() : "",
  //       CourseId: course.length > 0 ? course[1]?.Id.toString() : "",
  //       DesiId: JobTitle.length > 0 ? JobTitle[1]?.Id.toString() : "",
  //       Occupation: "S"
  //     };

  //     return initialFormData;
  //   };

  //   if (location.state && location.state?.EnqId) {
  //     setCurrentEnqId(location.state.EnqId);
  //     fetchEnquiryData(location.state?.EnqId, "R");
  //     setMode('view');
  //   } else {
  //     setMode('add');
  //     setIsFormDisabled(false);

  //     const timer = setTimeout(() => {
  //       setFormData(initializeFormData());
  //     }, 100);

  //     return () => clearTimeout(timer);
  //   }
  // }, [location, Propertydrp, sourceBy, Broker, EnqType, RoomType, Types, Relation, institutions, semester, course, JobTitle]);

  const checkPriviousList = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/TrnEnq/TrnEnqMobNoExists`, {
        PropId: parseInt(formData.PropId),
        MobileNo: formData.MobileNo,
        OcupntMob: formData.OcupntMob,
        Flag: ""
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setPreviousEnquiries(response.data.Data);
        setShowPreviousEnquiries(true);
      } else {
        toast.info("No previous enquiries found for this mobile number");
      }
    } catch (error) {
      toast.error('Error fetching previous enquiries. Please try again.');
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const enqIdFromQuery = searchParams.get("EnqId");

    const sessionData = sessionStorage.getItem('enquiryFormData');

    if (sessionData) {
      try {
        const parsed = JSON.parse(sessionData);
        const enqIdToLoad = parsed.EnqId;

        if (enqIdToLoad) {
          setCurrentEnqId(enqIdToLoad);
          setMode(parsed.mode || 'view');
          setIsFormDisabled(true);
          fetchEnquiryData({ EnqId: enqIdToLoad }, "R");
        }

        // Optional: Clear after successful load (recommended)
        sessionStorage.removeItem('enquiryFormData');
      } catch (error) {
        setMode('add');
        setIsFormDisabled(false);
      }
    }
    else if (enqIdFromQuery) {
      setCurrentEnqId(enqIdFromQuery);
      fetchEnquiryData({ EnqId: enqIdFromQuery }, "R");
      setMode('view');
      setIsFormDisabled(true);
    }
    else if (location.state && location.state?.EnqId) {
      setCurrentEnqId(location.state.EnqId);
      fetchEnquiryData(location.state.EnqId, "R");
      setMode('view');
      setIsFormDisabled(true);
    }
    else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  // useEffect(() => {
  //   const sessionData = sessionStorage.getItem('enquiryFormData');

  //   if (sessionData) {
  //     try {
  //       const { EnqId, rowData, mode } = JSON.parse(sessionData);

  //       setMode(mode || 'view');
  //       if (EnqId) {
  //         setCurrentEnqId(EnqId);
  //         fetchEnquiryData(EnqId, "R");
  //       }
  //       sessionStorage.removeItem('enquiryFormData');
  //     } catch (error) {
  //       setMode('add');
  //     }
  //   } else if (enqIdData) {
  //     setCurrentEnqId(enqIdData);
  //     fetchEnquiryData({ EnqId: enqIdData }, "R");
  //     setMode('view');
  //     setIsFormDisabled(true);
  //   }
  //   else if (location.state && location.state?.EnqId) {
  //     setCurrentEnqId(location?.state?.EnqId);
  //     fetchEnquiryData(location?.state?.EnqId, "R");
  //     setMode('view');
  //   }
  //   else {
  //     setMode('add');
  //     setIsFormDisabled(false);
  //   }
  // }, [location, enqIdData]);

  // useEffect(() => {

  //   if (location.state && location.state?.EnqId) {
  //     setCurrentEnqId(location?.state?.EnqId);
  //     fetchEnquiryData(location?.state?.EnqId, "R");
  //     setMode('view');
  //   } else {
  //     setMode('add');
  //     setIsFormDisabled(false);

  //   }
  // }, [location]);

  useEffect(() => {
    if (mode === 'add' && Types.length > 0) {
      const userName = localStorage.getItem("userName")?.trim();
      const matchedOption = Types.find(option => option.Name === userName);
      if (matchedOption) {
        setFormData(prev => ({
          ...prev,
          FlwUserId: matchedOption.Id,
        }));
      }
    }
  }, [Types, mode]);

  useEffect(() => {
    if (formData.VisitSt === "N") {
      setFormData(prevState => ({
        ...prevState,
        VisitDt: moment().format('DD/MM/YYYY')
      }));
    }
  }, [formData.VisitSt]);

  const fetchEnquiryData = async (id, flag) => {
    try {
      const response = await axios.post(`TrnEnq/RetriveTrnEnq`, {
        EnqId: parseInt(id.EnqId),
        Flag: flag,
        CreatedBy: UserId
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const enquiryData = response.data.Data[0];

        setEnqId(enquiryData?.EnqId)
        let enquiryStatus = 'open';
        if (enquiryData.Status === '0') {
          enquiryStatus = 'cancel';
        } else if (enquiryData.Status === '5') {
          enquiryStatus = 'close';
        }
        setFormData({
          PropId: enquiryData.PropId.toString() || '',
          EnqNo: enquiryData.EnqNo || '',
          EnqDt: enquiryData.EnqDt ? moment(enquiryData.EnqDt).format('DD/MM/YYYY') : '',
          SourceId: enquiryData.SourceId.toString() || '',
          SourceName: enquiryData.SourceName || '',
          BrokerId: enquiryData.BrokerId?.toString() || '',
          EnqType: enquiryData.EnqType || '',
          EnqBy: enquiryData.EnqBy || '',
          MobileNo: enquiryData.MobileNo || '',
          EmailId: enquiryData.EmailId || '',
          EnqFor: enquiryData.EnqFor || '',
          Address: enquiryData.Address || '',
          Tenure: enquiryData.Tenure || 0,
          CheckInDt: enquiryData.CheckInDt ? moment(enquiryData.CheckInDt).format('DD/MM/YYYY') : '',
          RoomTypeId: enquiryData.RoomTypeId.toString() || '',
          PreviousStayNm: enquiryData.PreviousStayNm || '',
          Remark: enquiryData.Remark || '',
          enquiryStatus: enquiryStatus,
          BookId: enquiryData.BookId?.toString() || '',
          FlwUserId: enquiryData.FlwUserId?.toString() || '',
          VisitSt: enquiryData.VisitSt || '',
          VisitDt: enquiryData.VisitDt ? moment(enquiryData.VisitDt).format('DD/MM/YYYY') : '',
          NextFlwDt: enquiryData.NextFlwDt ? moment(enquiryData.NextFlwDt).format('DD/MM/YYYY') : '',
          VisitUserId: enquiryData.VisitUserId?.toString() || '',
          FlwUserId: enquiryData.FlwUserId?.toString() || "",
          VisitRemark: enquiryData.VisitRemark || '',
          CanlDt: enquiryData.CanlDt || '',
          CanlUserId: enquiryData.CanlUserId || '',
          CanlRemark: enquiryData.CanlRemark || '',
          RelationId: enquiryData.RelationId?.toString() || '',
          InstituteId: enquiryData.InstituteId?.toString() || '',
          SemesterId: enquiryData.SemesterId?.toString() || '',
          CourseId: enquiryData.CourseId?.toString() || '',
          DesiId: enquiryData.DesiId.toString() || '',
          Occupation: enquiryData.Occupation || '',
          OcupntMob: enquiryData.OcupntMob || ''
        });

        setStatus(enquiryData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentEnqId(enquiryData.EnqId);
        setTypedBookNo(enquiryData.BookNo || "");
        if (enquiryData.PropId) {
          await fetchEmpTypes(enquiryData.PropId.toString());
        }
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch enquiry data');
      }
    } catch (error) {
      toast.error('Error fetching enquiry data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };

      try {
        const res = await axios.post('TrnEnq/GetTrnEnqDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentEnqId && currentEnqId > 1) {
      await fetchEnquiryData({ EnqId: currentEnqId }, "P");
    }
  };

  const handleNext = async () => {
    if (currentEnqId) {
      await fetchEnquiryData({ EnqId: currentEnqId }, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'EnqDt') {
      setShowCalendar(false);
    } else if (name === 'CheckInDt') {
      setDisplayCalendar(false);
    } else if (name === 'VisitDt') {
      setViewCalendar(false);
    } else if (name === 'NextFlwDt') {
      setFollowCalendar(false);
    }
    if (name === 'VisitSt') {
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        VisitUserId: value === "Y" && Types.length > 0 ? Types[0].Id.toString() : "",
        VisitDt: value === "N" ? moment().format('DD/MM/YYYY') : prevState.VisitDt
      }));
      return;
    }

    if (name === 'MobileNo') {
      setFormData(prevState => {
        const newState = {
          ...prevState,
          MobileNo: value
        };

        if (!prevState.OcupntMob || prevState.OcupntMob === prevState.MobileNo) {
          newState.OcupntMob = value;
        }

        return newState;
      });
      return;
    }

    if (name === 'OcupntMob') {
      setFormData(prevState => ({
        ...prevState,
        OcupntMob: value
      }));
      return;
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'Enquiry') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }
  };

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;

  //   console.log("value", value);
  //   if (name === 'EnqDt') {
  //     setShowCalendar(false);
  //   } else if (name === 'CheckInDt') {
  //     setDisplayCalendar(false);
  //   } else if (name === 'VisitDt') {
  //     setViewCalendar(false);
  //   } else if (name === 'NextFlwDt') {
  //     setFollowCalendar(false);
  //   }
  //   if (name === 'VisitSt') {
  //     setFormData(prevState => ({
  //       ...prevState,
  //       [name]: value,
  //       VisitUserId: value === "Y" && Types.length > 0 ? Types[0].Id.toString() : "", // Set first value when Yes
  //       VisitDt: value === "N" ? moment().format('DD/MM/YYYY') : prevState.VisitDt
  //     }));
  //   } else {
  //     setFormData(prevState => ({
  //       ...prevState,
  //       [name]: value
  //     }));
  //   }


  //   if (name === 'Enquiry') {
  //     setFormData(prevState => ({
  //       ...prevState,
  //       state: ''
  //     }));
  //   }

  //   // if (name === 'Enquiry' && value !== '') {
  //   //   setTimeout(() => {
  //   //     SourceNameRef.current.focus();
  //   //   }, 100000);
  //   // }
  // };

  const handlePropertyChange = (event) => {
    const { name, value } = event.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (value) {
      const selectedPropertyId = value;
      setFormData(prev => ({ ...prev, PropId: selectedPropertyId }));
      fetchEmpTypes(selectedPropertyId);
    } else {
      setFormData(prev => ({ ...prev, PropId: null }));
      setTypes([]);
    }

  };

  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const response = await axios.post(`PropertyMst/GetPropertyMstUserwisedrp`, {
          UserId,
          Flag: ""
        });

        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          const properties = response.data.Data;
          setPropertydrp(properties);
        } else {
          toast.error('Failed to fetch Property');
        }
      } catch (error) {
        toast.error('Error fetching Property. Please try again.');
      }
    };

    fetchPropertyData();
  }, []);

  useEffect(() => {
    const sourceByName = async () => {
      try {
        const response = await axios.post(`MstSource/getMstSourcedrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setsourceBy(response.data.Data);
        } else {
          toast.error('Failed to fetch SourceBy');
        }
      } catch (error) {
        toast.error('Error fetching SourceBy. Please try again.');
      }
    };

    sourceByName();
  }, []);

  useEffect(() => {
    const getRelation = async () => {
      try {
        const response = await axios.post(`MstRelation/getMstRelationdrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setRelation(response.data.Data);
        } else {
          toast.error('Failed to fetch Relation');
        }
      } catch (error) {
        toast.error('Error fetching Relation. Please try again.');
      }
    };

    getRelation();
  }, []);

  useEffect(() => {
    const getJobTitle = async () => {
      try {
        const response = await axios.post(`MstDesi/getMstDesidrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setJobTitle(response.data.Data);
        } else {
          toast.error('Failed to fetch JobTitle');
        }
      } catch (error) {
        toast.error('Error fetching JobTitle. Please try again.');
      }
    };

    getJobTitle();
  }, []);

  useEffect(() => {
    const GetInstituteeName = async () => {
      try {
        const response = await axios.post(`MstInstitute/getMstInstitutedrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setInstitutions(response.data.Data);
        } else {
          toast.error('Failed to fetch Institute');
        }
      } catch (error) {
        toast.error('Error fetching Institute. Please try again.');
      }
    };

    GetInstituteeName();
  }, []);

  useEffect(() => {
    const GetCourseName = async () => {
      try {
        const response = await axios.post(`MstCourse/getMstCoursedrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setCourse(response.data.Data);
        } else {
          toast.error('Failed to fetch Course');
        }
      } catch (error) {
        toast.error('Error fetching Course. Please try again.');
      }
    };

    GetCourseName();
  }, []);

  useEffect(() => {
    const GetSemesterName = async () => {
      try {
        const response = await axios.post(`MstSemester/getMstSemesterdrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setSemester(response.data.Data);
        } else {
          toast.error('Failed to fetch Semester');
        }
      } catch (error) {
        toast.error('Error fetching Semester. Please try again.');
      }
    };

    GetSemesterName();
  }, []);

  useEffect(() => {
    const BrokerCategory = async () => {
      try {
        const response = await axios.post(`PartyMst/getPartyMstdrp`, {
          "PartyCat": "BR"
        });
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setBroker(response.data.Data);
        } else {
          toast.error('Failed to fetch Broker');
        }
      } catch (error) {
        toast.error('Error fetching Broker. Please try again.');
      }
    };

    BrokerCategory();
  }, []);

  useEffect(() => {
    const enquiryType = async () => {
      try {
        const response = await axios.post(`MstEnqTp/GetMstEnqTpDrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setEnqType(response.data.Data);
        } else {
          toast.error('Failed to fetch EnquiryType');
        }
      } catch (error) {
        toast.error('Error fetching EnquiryType. Please try again.');
      }
    };

    enquiryType();
  }, []);

  useEffect(() => {
    const roomType = async () => {
      try {
        const response = await axios.post(
          `RoomMst/getdrpRoomTypeMst`
        );
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setRoomType(response.data.Data);
        } else {
          toast.error('Failed to fetch RoomType');
        }
      } catch (error) {
        toast.error('Error fetching RoomType. Please try again.');
      }
    };

    roomType();
  }, []);

  const fetchEmpTypes = async (propertyIds) => {
    try {
      const response = await axios.post(`UserMst/getAllUserMstDashBoard`, {
        "SearchText": propertyIds
      });
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setTypes(response.data.Data);
      } else {
        toast.error('Failed to fetch empTypes');
      }
    } catch (error) {
      toast.error('Error fetching empTypes. Please try again.');
    }
  };

  useEffect(() => {
    if (typedBookNo && typedBookNo.length >= 8) {
      fetchBookId(typedBookNo, "M");
    }
  }, [typedBookNo]);

  const fetchBookId = async (e, Separator) => {

    let val = "";
    if (Separator === "E") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    setTypedBookNo(val);

    if (val.length >= 8) {
      try {
        const response = await axios.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": '',
            "Flag": '',
            "MobileNo": '',
            "BookNo": val,
            "PropId": 1,
          }
        );
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          const fetchedBookId = response.data.Data[0];
          setBookNo(fetchedBookId);
          setFormData(prev => ({
            ...prev,
            BookId: fetchedBookId.BookId,
          }));
          setIsBookIdValid(true);
        }
        else {
          setIsBookIdValid(false);
        }
      } catch (error) {
        toast.error('Error fetching BookId. Please try again.');
        setIsBookIdValid(false);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === SourceNameRef.current) {
        EnqTypeRef.current.focus();
      } else if (event.target === EnqTypeRef.current) {
        MobileNoRef.current.focus();
      } else {
        MobileNoRef.current.focus();
      }
    }
  };

  useEffect(() => {
    const formatted = formatDate(tomorrowDate);
    setFormData((prev) => ({ ...prev, NextFlwDt: formatted }));
  }, []);

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const formatDate = (date) => {
    if (date) {
      return moment(date, 'DD/MM/YYYY').format('DD-MM-YYYY');
    }
    return '';
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prevState) => ({ ...prevState, EnqDt: formatDate(date) }));
    setShowCalendar(false);
  };

  const handleDate = (date) => {
    setSelectedDate(date);
    setFormData((prevState) => ({ ...prevState, CheckInDt: formatDate(date) }));
    setDisplayCalendar(false);
  };

  const dateHandler = (date) => {
    setSelectedDate(date);
    setFormData((prevState) => ({ ...prevState, VisitDt: formatDate(date) }));
    // setShowCalendar(false);
    setViewCalendar(false);
  };

  const dateFollowHandler = (date) => {
    setTomorrowDate(date);
    setFormData((prevState) => ({ ...prevState, NextFlwDt: formatDate(date) }));
    setFollowCalendar(false);
  };

  const handleSave = async () => {

    let hasError = false;

    const mobileRegex = /^\d{10}$/;

    const allFieldsEmpty = !formData.PropId && !formData.EnqBy && !formData.EnqFor && !formData.MobileNo &&
      !formData.CheckInDt && !formData.FlwUserId;

    if (allFieldsEmpty) {
      toast.error("Please fill all input fields");

      setError({
        PropId: true,
        EnqBy: true,
        EnqFor: true,
        MobileNo: true,
        CheckInDt: true,
        FlwUserId: true
      });

      return;
    }

    if (!formData.PropId) {
      toast.error("Property is required");
      setError(prev => ({ ...prev, PropId: true }));
      return;
    } else {
      setError(prev => ({ ...prev, PropId: false }));
    }

    if (!formData.EnqBy) {
      toast.error("EnquiryBy is required");
      setError(prev => ({ ...prev, EnqBy: true }));
      return;
    } else {
      setError(prev => ({ ...prev, EnqBy: false }));
    }

    if (!formData.EnqFor) {
      toast.error("Occupant Name is required");
      setError(prev => ({ ...prev, EnqFor: true }));
      return;
    } else {
      setError(prev => ({ ...prev, EnqFor: false }));
    }

    if (!formData.MobileNo) {
      toast.error("Mobile No is required");
      setError(prev => ({ ...prev, MobileNo: true }));
      return;
    } else if (!mobileRegex.test(formData.MobileNo)) {
      toast.error("Please enter a valid 10-digit mobile number");
      setError(prev => ({ ...prev, MobileNo: true }));
      return;
    } else {
      setError(prev => ({ ...prev, MobileNo: false }));
    }

    if (!formData.CheckInDt) {
      toast.error("Tentitive CheckIn Date is required");
      setError(prev => ({ ...prev, CheckInDt: true }));
      return;
    } else {
      setError(prev => ({ ...prev, CheckInDt: false }));
    }

    if (!formData.FlwUserId) {
      toast.error("Follow By is required");
      setError(prev => ({ ...prev, FlwUserId: true }));
      return;
    } else {
      setError(prev => ({ ...prev, FlwUserId: false }));
    }

    try {
      const payload = {
        PropId: parseInt(formData.PropId),
        EnqDt: formData.EnqDt ? moment(formData.EnqDt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        SourceId: parseInt(formData.SourceId) || 1,
        EnqNo: formData.EnqNo,
        SourceName: formData.SourceName,
        BrokerId: parseInt(formData.BrokerId) || 1,
        EnqType: formData.EnqType,
        EnqBy: formData.EnqBy,
        MobileNo: formData.MobileNo,
        OcupntMob: formData.OcupntMob,
        EmailId: formData.EmailId,
        EnqFor: formData.EnqFor,
        Address: formData.Address || "",
        Tenure: formData.Tenure,
        CheckInDt: formData.CheckInDt ? moment(formData.CheckInDt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        RoomTypeId: parseInt(formData.RoomTypeId) || 1,
        PreviousStayNm: formData.PreviousStayNm,
        Remark: formData.Remark || "",
        NextFlwDt: formData.NextFlwDt ? moment(formData.NextFlwDt, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
        Status: Status,
        FlwUserId: parseInt(formData.FlwUserId) || 1,
        BookId: parseInt(formData.BookId, 10) || 1,
        // FlwEmpId: 1,
        VisitSt: formData.VisitSt,
        VisitDt: formData.VisitDt ? moment(formData.VisitDt, 'DD/MM/YYYY').format('YYYY-MM-DD') : "01/01/1990",
        VisitUserId: formData.VisitUserId ? parseInt(formData.VisitUserId) : 1,
        VisitRemark: formData.VisitRemark,
        CanlDt: "2025-02-26",
        CanlUserId: 1,
        CanlRemark: "",
        RelationId: parseInt(formData.RelationId) || 1,
        InstituteId: parseInt(formData.InstituteId) || 1,
        SemesterId: parseInt(formData.SemesterId) || 1,
        CourseId: parseInt(formData.CourseId) || 1,
        DesiId: parseInt(formData.DesiId) || 1,
        Occupation: formData.Occupation
      };

      let response;
      if (mode === 'edit') {

        if (typedBookNo) {
          if (typedBookNo.length < 8 || !isBookIdValid) {
            toast.error("Invalid Booking No");
            setError(prev => ({ ...prev, BookId: true }));
            return;
          }
        }

        payload.EnqId = currentEnqId;
        payload.UpdatedBy = parseInt(UserId, 10);
        payload.CanlRemark = formData.CanlRemark;
        payload.CanlUserId = UserId;
        payload.Status = formData.enquiryStatus === 'open' ? '1' :
          formData.enquiryStatus === 'close' ? '5' :
            formData.enquiryStatus === 'cancel' ? '0' : '1';
        response = await axios.post('TrnEnq/UpdateTrnEnq', payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post('TrnEnq/InsertTrnEnq', payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedEnqId(response.data.Data)
          await fetchEnquiryData({ EnqId: 1 }, "L");
          setMode('view');
          setIsFormDisabled(true);
          setCurrentEnqId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      toast.error('Error saving/updating enquiry. Please try again.');
    }
  };

  const handleEdit = () => {
    setMode('edit')
    setIsFormDisabled(false);
  };

  useEffect(() => {
    if (mode === 'add' && Propertydrp.length > 0) {
      const initialFormData = {
        PropId: Propertydrp[0]?.Id.toString() || "",
        EnqNo: "",
        EnqDt: moment().format('DD/MM/YYYY'),
        SourceId: sourceBy.length > 0 ? sourceBy[1]?.Id.toString() : "",
        SourceName: "",
        BrokerId: Broker.length > 0 ? Broker[1]?.Id.toString() : "",
        EnqType: EnqType.length > 0 ? EnqType[1]?.Id.toString() : "",
        EnqBy: "",
        MobileNo: "",
        EmailId: "",
        EnqFor: "",
        Address: "",
        Tenure: "0",
        CheckInDt: moment().format('DD/MM/YYYY'),
        RoomTypeId: RoomType.length > 0 ? RoomType[1]?.Id.toString() : "",
        PreviousStayNm: "",
        Remark: "",
        Status: "",
        NextFlwDt: moment().add(1, 'days').format('DD/MM/YYYY'),
        BookId: "",
        FlwUserId: "",
        VisitSt: "N",
        VisitDt: moment().format('DD/MM/YYYY'),
        VisitUserId: "",
        VisitRemark: "",
        CanlDt: "",
        CanlUserId: "",
        CanlRemark: "",
        CreatedBy: "",
        RelationId: Relation.length > 0 ? Relation[1]?.Id.toString() : "",
        InstituteId: institutions.length > 0 ? institutions[1]?.Id.toString() : "",
        SemesterId: semester.length > 0 ? semester[1]?.Id.toString() : "",
        CourseId: course.length > 0 ? course[1]?.Id.toString() : "",
        DesiId: JobTitle.length > 0 ? JobTitle[1]?.Id.toString() : "",
        Occupation: "S"
      };

      setFormData(initialFormData);
      fetchEmpTypes(Propertydrp[0]?.Id);
    }
  }, [mode, Propertydrp, sourceBy, Broker, EnqType, RoomType, Relation, institutions, semester, course, JobTitle]);


  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);

    const selectedPropId = Propertydrp.length > 0 ? Propertydrp[0].Id.toString() : "";

    // Set first values for dropdown fields if they exist
    const initialFormData = {
      PropId: selectedPropId,
      EnqNo: "",
      EnqDt: moment().format('DD/MM/YYYY'),
      SourceId: sourceBy.length > 0 ? sourceBy[1].Id.toString() : "",
      SourceName: "",
      BrokerId: Broker.length > 0 ? Broker[1].Id.toString() : "",
      EnqType: EnqType.length > 0 ? EnqType[1].Id.toString() : "",
      EnqBy: "",
      MobileNo: "",
      EmailId: "",
      EnqFor: "",
      Address: "",
      Tenure: "0",
      CheckInDt: moment().format('DD/MM/YYYY'),
      RoomTypeId: RoomType.length > 0 ? RoomType[1].Id.toString() : "",
      PreviousStayNm: "",
      Remark: "",
      Status: "",
      NextFlwDt: moment().add(1, 'days').format('DD/MM/YYYY'),
      BookId: "",
      FlwUserId: "",
      VisitSt: "N",
      VisitDt: moment().format('DD/MM/YYYY'),
      VisitUserId: "",
      VisitRemark: "",
      CanlDt: "",
      CanlUserId: "",
      CanlRemark: "",
      CreatedBy: "",
      RelationId: Relation.length > 0 ? Relation[1].Id.toString() : "",
      InstituteId: institutions.length > 0 ? institutions[1].Id.toString() : "",
      SemesterId: semester.length > 0 ? semester[1].Id.toString() : "",
      CourseId: course.length > 0 ? course[1].Id.toString() : "",
      DesiId: JobTitle.length > 0 ? JobTitle[1].Id.toString() : "",
      Occupation: "S",
      OcupntMob: ''
    };

    if (selectedPropId) {
      fetchEmpTypes(selectedPropId);
    }

    setFormData(initialFormData);
    setCurrentEnqId(null);
    setTypedBookNo("");
  };

  const handleCancel = async () => {
    try {
      await fetchEnquiryData({ EnqId: 1 }, "L");
      setStatus("1");
      setMode('view');
      setIsFormDisabled(true);
      setError({ // Reset error state
        EnqBy: false,
        EnqFor: false,
        MobileNo: false,
        CheckInDt: false,
        FlwUserId: false,
        PropId: false,
      });
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const handleExit = () => {
    navigate('/enquirytable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await fetchEnquiryData({ EnqId: currentEnqId }, "D");
      await fetchEnquiryData({ EnqId: currentEnqId }, "N");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error deleting . Please try again.');
    }
    setOpenConfirmDialog(false);
  };

  const handlClickNaviagate = () => {
    sessionStorage.setItem('followupFormData', JSON.stringify({
      EnqId: enqId || formData.EnqId,
      mode: 'view',
      timestamp: Date.now()
    }));

    // Keep enquiry data as backup
    sessionStorage.setItem('enquiryFormData', JSON.stringify({
      EnqId: currentEnqId,
      mode: 'view'
    }));
    navigate('/FollowupForm', { state: { EnqId: enqId, mode: 'view', fromEnquiry: true } });
  };

  return (
    <>
      <ToastContainer />
      <Box className="form-container">
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={mode !== 'view' || !currentEnqId || currentEnqId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: { xs: "none", sm: "block" },
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== 'view' || !currentEnqId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Enquiry Registration
            </Typography>
            <Tooltip title='Back to previous page' arrow>
              <Button size='small' startIcon={<ArrowBackIcon />} variant='contained' onClick={() => navigate(-1)}
                sx={{ bgcolor: '#635bff', ":hover": { bgcolor: '#635bff' } }}>Back</Button></Tooltip>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Enquiry"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              background: '#5c6bc0',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              color: 'white',
              padding: '2px 8px',
              borderRadius: '5px',
              lineHeight: 1.5,
              position: "relative",
              top: 12,
              marginRight: 1,
              left: {
                xs: 86,
                sm: 440,
                md: 680,
                lg: 760,
                xl: 760
              }
            }}
          >
            <ArrowForwardIcon sx={{ mr: 0.5 }} />
            <Typography variant="body2" sx={{ color: 'white', cursor: 'pointer' }}
              onClick={handlClickNaviagate}
            >
              Follow Up
            </Typography>
          </Box>

          <Grid item xs={12} md={12} lg={12} className="form_field"
            sx={{ marginInline: { xs: "10px", sm: "80px" } }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={4}>
                    <CustomAutocomplete
                      options={Propertydrp}
                      id="PropId-autocomplete"
                      name='PropId'
                      label={
                        <span>
                          Property<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={Propertydrp.find(PropId => PropId.Id == formData.PropId) || null}
                      onChange={handlePropertyChange}
                      disabled={isFormDisabled}
                      error={error.PropId}
                      helperText={error.PropId ? '' : ''}
                    // ref={stateRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      id="EnqNo"
                      name="EnqNo"
                      label="Enquiry No"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.EnqNo}
                      onChange={handleInputChange}
                      disabled={true}
                    // inputRef={pinCodeRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Enquiry Date"
                      name="EnqDt"
                      value={formData.EnqDt}
                      onChange={handleInputChange}
                      variant="filled"
                      disabled={isFormDisabled}
                      onBlur={() => setShowCalendar(false)}
                      className="custom-textfield"
                      // onClick={() => !isFormDisabled && setShowCalendar(!showCalendar)}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" >
                            <CalendarMonthIcon
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                !isFormDisabled && setShowCalendar(!showCalendar);
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {showCalendar && !isFormDisabled && (
                      <div className="calendar-container"
                        style={{
                          position: 'absolute',
                          zIndex: 1000,
                          width: '280px',
                          fontSize: '25.4px',
                          height: '200px',
                        }}
                      >
                        <Calendar
                          onChange={handleDateChange}
                          value={selectedDate}
                        />
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="BookId"
                      name="BookId"
                      label="Booking No"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      // value={BookNo.find(BookId => BookId.Id == formData.BookId) || null}
                      value={typedBookNo}
                      onChange={(e) => fetchBookId(e, 'E')}
                      disabled={isFormDisabled || mode === "add"}
                      error={error.BookId}
                      helperText={error.BookId ? '' : ''}
                    // inputRef={pinCodeRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="EnqBy"
                      name="EnqBy"
                      label={
                        <span>
                          Enq By<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.EnqBy}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                      error={error.EnqBy}
                      helperText={error.EnqBy ? '' : ''}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      options={Relation}
                      id="RelationId-autocomplete"
                      name='RelationId'
                      label="Relation"
                      value={Relation.find(RelationId => RelationId.Id == formData.RelationId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={stateRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      id="EnqFor"
                      name="EnqFor"
                      label={
                        <span>
                          Occupant Name<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.EnqFor}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                      error={error.EnqFor}
                      helperText={error.EnqFor ? '' : ''}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={2}>
                    <TextField
                      id="MobileNo"
                      name="MobileNo"
                      label={
                        <span>
                          Mobile No<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.MobileNo}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                      error={error.MobileNo}
                      helperText={error.MobileNo ? '' : ''}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      id="OcupntMob"
                      name="OcupntMob"
                      label="Occupant MobileNo"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.OcupntMob}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                      error={error.OcupntMob}
                      helperText={error.OcupntMob ? 'Invalid mobile number' : ''}
                    />
                  </Grid>
                  <Grid item xs={6} md={1.1} sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* <Button
                      size="small"
                      variant='contained'
                      sx={{
                        whiteSpace: 'nowrap',
                        minWidth: 'auto',
                        px: 1,
                        height: '100%'
                      }}
                      onClick={checkPriviousList}
                      disabled={!formData.MobileNo || isFormDisabled}
                    >
                      Visit List
                    </Button> */}
                    <Stack >
                      <Chip
                        label="Check List"
                        color="error"
                        size="small"
                        variant="filled"
                        onClick={checkPriviousList}
                        disabled={!formData.MobileNo || isFormDisabled}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={2.5}>
                    <TextField
                      id="EmailId"
                      name="EmailId"
                      label="Email ID"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.EmailId}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={4.3}>
                    <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                      <Grid item>
                        <FormLabel component="legend">Occupation</FormLabel>
                      </Grid>

                      <Grid item>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="Occupation"
                            name="Occupation"
                            value={formData.Occupation}
                            onChange={handleInputChange}
                            row
                          >
                            <FormControlLabel
                              value="S"
                              control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                              label="Student"
                              className="custom-textfield"
                              disabled={isFormDisabled}
                            />
                            <FormControlLabel
                              value="W"
                              control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                              label="Service"
                              className="custom-textfield"
                              disabled={isFormDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="DesiId-autocomplete"
                      name='DesiId'
                      label="Job Title"
                      options={JobTitle}
                      value={JobTitle.find(DesiId => DesiId.Id == formData.DesiId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="InstituteId-autocomplete"
                      name='InstituteId'
                      label="Institute/Corporate"
                      options={institutions}
                      value={institutions.find(InstituteId => InstituteId.Id == formData.InstituteId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="CourseId-autocomplete"
                      name='CourseId'
                      label="Course"
                      options={course}
                      value={course.find(CourseId => CourseId.Id == formData.CourseId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="SemesterId-autocomplete"
                      name='SemesterId'
                      label="Semester"
                      options={semester}
                      value={semester.find(SemesterId => SemesterId.Id == formData.SemesterId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="EnqType-autocomplete"
                      name='EnqType'
                      label={
                        <span>
                          Enq Type<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      options={EnqType}
                      value={EnqType.find(EnqType => EnqType.Id == formData.EnqType) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="SourceId-autocomplete"
                      name='SourceId'
                      label={
                        <span>
                          Source By<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      options={sourceBy}
                      value={sourceBy.find(SourceId => SourceId.Id == formData.SourceId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="SourceName"
                      name="SourceName"
                      label="Source Name"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.SourceName}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="BrokerId-autocomplete"
                      name='BrokerId'
                      label="Broker"
                      options={Broker}
                      value={Broker.find(BrokerId => BrokerId.Id == formData.BrokerId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="RoomTypeId-autocomplete"
                      name='RoomTypeId'
                      label="Room Type"
                      options={RoomType}
                      value={RoomType.find(RoomTypeId => RoomTypeId.Id == formData.RoomTypeId) || null}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // ref={cityRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="Tenure"
                      name="Tenure"
                      label="Tenure"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.Tenure}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Tentitive CheckIn Date"
                      name="CheckInDt"
                      value={formData.CheckInDt}
                      onChange={handleInputChange}
                      onBlur={() => setDisplayCalendar(false)}
                      variant="filled"
                      disabled={isFormDisabled}
                      error={error.CheckInDt}
                      helperText={error.CheckInDt ? '' : ''}
                      className="custom-textfield"
                      onClick={() => !isFormDisabled && setDisplayCalendar(!displayCalendar)}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" >
                            <CalendarMonthIcon
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                !isFormDisabled && setDisplayCalendar(!displayCalendar);
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {displayCalendar && !isFormDisabled && (
                      <div className="calendar-container"
                        style={{
                          position: 'absolute',
                          zIndex: 1000,
                          width: '280px',
                          bottom: 282,
                          fontSize: '25.4px',
                          height: '200px',
                        }}
                      >
                        <Calendar
                          onChange={handleDate}
                          value={selectedDate}
                        />
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="PreviousStayNm"
                      name="PreviousStayNm"
                      label="Previously Stay"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.PreviousStayNm}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <CustomAutocomplete
                      id="FlwUserId-autocomplete"
                      name='FlwUserId'
                      label={
                        <span>
                          Follow By<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      options={Types}
                      value={Types.find(FlwUserId => FlwUserId.Id == formData.FlwUserId) || null}
                      onChange={handleInputChange}
                      // disabled={formData.VisitSt === "N" || isFormDisabled}
                      disabled={isFormDisabled}
                      error={error.FlwUserId}
                      helperText={error.FlwUserId ? '' : ''}
                      getOptionLabel={(option) => option.Name || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.Id.toString() === (value?.Id?.toString() || value?.toString())
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item>
                        <FormLabel component="legend">Visited</FormLabel>
                      </Grid>
                      <Grid item>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="VisitSt"
                            name="VisitSt"
                            value={formData.VisitSt}
                            onChange={handleInputChange}
                            row
                          >
                            <FormControlLabel
                              value="Y"
                              control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                              label="Yes"
                              className="custom-textfield"
                              disabled={isFormDisabled}
                            />
                            <FormControlLabel
                              value="N"
                              control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                              label="No"
                              className="custom-textfield"
                              disabled={isFormDisabled}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Autocomplete
                      options={Types}
                      getOptionLabel={(option) => option.Name || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.Id.toString() === (value?.Id?.toString() || value?.toString())
                      }
                      value={
                        formData.VisitUserId
                          ? Types.find(visitEmp => visitEmp.Id.toString() === formData.VisitUserId.toString())
                          : null
                      }
                      onChange={(event, newValue) => {
                        setFormData(prevState => ({
                          ...prevState,
                          VisitUserId: newValue ? newValue.Id.toString() : ""
                        }));
                      }}
                      disabled={formData.VisitSt === "N" || isFormDisabled}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Visited With"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Visited Date"
                      name="VisitDt"
                      value={formData.VisitDt}
                      onChange={handleInputChange}
                      onBlur={() => setViewCalendar(false)}
                      variant="filled"
                      disabled={formData.VisitSt === "N" || isFormDisabled}
                      className="custom-textfield"
                      onClick={() => !isFormDisabled && setViewCalendar(!viewCalendar)}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" >
                            <CalendarMonthIcon style={{ cursor: 'pointer' }} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {viewCalendar && !isFormDisabled && formData.VisitSt !== "N" && (
                      <div className="calendar-container"
                        style={{
                          position: 'absolute',
                          zIndex: 1000,
                          width: '280px',
                          fontSize: '25.4px',
                          bottom: 232,
                          height: '200px',
                        }}
                      >
                        <Calendar
                          onChange={dateHandler}
                          value={selectedDate}
                        />
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label={
                        <span>
                          Next Followup Date<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="NextFlwDt"
                      value={formData.NextFlwDt}
                      onChange={handleInputChange}
                      variant="filled"
                      disabled={isFormDisabled}
                      error={error.NextFlwDt}
                      helperText={error.NextFlwDt ? '' : ''}
                      className="custom-textfield"
                      // onClick={() => !isFormDisabled && setFollowCalendar(!FollowCalendar)}
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" >
                            <CalendarMonthIcon style={{ cursor: 'pointer' }} />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {FollowCalendar && !isFormDisabled && (
                      <div className="calendar-container"
                        style={{
                          position: 'absolute',
                          zIndex: 1000,
                          width: '280px',
                          bottom: 160,
                          fontSize: '25.4px',
                          height: '200px',
                        }}
                      >
                        <Calendar
                          onChange={dateFollowHandler}
                          value={tomorrowDate}
                        />
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      id="Address"
                      name="Address"
                      label="Address"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.Address}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <FormLabel component="legend" sx={{ whiteSpace: 'nowrap' }}>Enquiry Status</FormLabel>
                        <RadioGroup
                          row
                          name="enquiryStatus"
                          value={formData.enquiryStatus || 'open'}
                          onChange={handleInputChange}

                        >
                          <FormControlLabel value="open" disabled={isFormDisabled} control={<Radio />} label="Open" />
                          <FormControlLabel value="close" disabled={isFormDisabled} control={<Radio />} label="Close" />
                          <FormControlLabel value="cancel" disabled={isFormDisabled} control={<Radio />} label="Cancel" />
                        </RadioGroup>
                      </Stack>
                    </FormControl>
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="VisitRemark"
                      name="VisitRemark"
                      label="Visit Remark"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={formData.VisitRemark}
                      onChange={handleInputChange}
                      disabled={isFormDisabled}
                    // inputRef={areaAbrvRef}
                    // onKeyDown={handleKeyPress}
                    />

                  </Grid>
                  <Grid item xs={12} md={5}>
                    {formData.enquiryStatus === "cancel" ?
                      <TextField
                        id="CanlRemark"
                        name="CanlRemark"
                        label="Cancel Remark"
                        variant="filled"
                        fullWidth
                        className="custom-textfield"
                        value={formData.CanlRemark}
                        onChange={handleInputChange}
                        disabled={isFormDisabled}
                      // inputRef={areaAbrvRef}
                      // onKeyDown={handleKeyPress}
                      />
                      :
                      <TextField
                        id="Remark"
                        name="Remark"
                        label="Remark"
                        variant="filled"
                        fullWidth
                        className="custom-textfield"
                        value={formData.Remark}
                        onChange={handleInputChange}
                        disabled={isFormDisabled}
                      // inputRef={areaAbrvRef}
                      // onKeyDown={handleKeyPress}
                      />
                    }
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={isFormDisabled}
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Grid>

          <div style={{ display: 'none' }}>
            {Object.keys(DataForPrint).length > 0 && <ReportTable
              columns={columns}
              rows={rows}
              title="Enquiry Registration"
              contentRef={contentRef}
              customStyles={{ backgroundColor: '#f5f5f5' }}
            />
            }
          </div>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #d4d4d4)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave} >
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
        <PreviousEnquiriesList
          open={showPreviousEnquiries}
          onClose={() => setShowPreviousEnquiries(false)}
          data={previousEnquiries}
        />
      </Box>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default EnquiryMain
